/**
 * @file Print.ts
 * @description This module provides utilities to work with the browser's print API
 *
 * @module Print
 */
/**
 * Opens the print dialog to print the current document.
 * You might need to check for availability because some mobile browsers don't support printing.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/print#browser_compatibility
 *
 * @example
 *
 * ```ts
 * import { Print } from '@catawiki/runtime-toolkit';
 *
 * Printing.openDialog();
 * ```
 *
 * In test environments, you can mock the `window.print` as this functionality if not implemented in most testing environments
 * like Jest, or just simply to avoid printing
 *
 * ```ts
 * // Mocking the window.print function with jest
 * jest.spyOn(window, 'print').mockImplementation(noop);
 * ```
 */
export const openDialog = () => window.print?.();
